<template>
<div>
  <div class="function_list">
    <div class="left_function" @click="jumpClgl()">
      <div class="function_label">
        车辆管理
        <div class="function_desc">
          管理您的车辆
        </div>
      </div>
      <img src="@/assets/images/manager_car.png" class="car_img"/>

      <div>

      </div>
    </div>
    <div class="right_function" @click="callPhone()">
      <div class="function_label">
        联系客服
        <div class="function_desc">
          有疑问找客服
        </div>
      </div>
      <img src="@/assets/images/customer.png" class="customer_img"/>
      <div>

      </div>
    </div>

  </div>
  <div class="panel-item-box">
    <div v-for="(item,index) in optionList" :key="index" class="options-item" @click="handleItemClick(item, index)"
    v-bind:style="item.item_style"
    >
      <div class="options-item-left">
        <div class="left-label">
          {{item.label}}

        </div>
        <div>
          {{item.desc}}
        </div>
      </div>
      <div class="options-item-right">
        <img :src="item.image"  />
      </div>
    </div>
    <vip-travel :isVip="isVip" :vipState="vipState" ></vip-travel>
  </div>
  <div class="container">
    <!-- 其他内容 -->
    <van-button type="primary" round class="fab" color="#299ff1" @click="handleMap">园区路线</van-button>
  </div>

  <div> 
    <van-dialog v-model="mapShow" title="园区路线图">
      <div style="margin-bottom:10px;">根据园区规定：从双良路进-过福太路-到润华路-到苏豪丽天智储。出：直接润华路出园区。</div>
      <img class="mapImage" src="../../assets/images/luxiantu.jpg" />
    </van-dialog>
  </div>

  <!-- 新增 - 小程序跳转弹窗 (使用 v-show 避免 DOM 重建) -->
  <div v-show="showWeappDialog" class="weapp-dialog-mask" @click.self="showWeappDialog = false">
    <div class="weapp-dialog">
      <div class="dialog-header">
        <h3>提示</h3>
        <!-- <button class="close-btn" @click="showWeappDialog = false">×</button> -->
      </div>
      <div class="dialog-content">
        <p style="font-weight: bold; font-size: 1rem;">即将打开“苏豪丽天智储预约”小程序</p>
        <p class="tip">预约蒸洗功能需要在小程序中完成</p>
      </div>
      <div class="dialog-footer">
        <button class="btn-cancel" @click="showWeappDialog = false">取消</button>
        <!-- 不要 v-if，直接一个容器，初始显示 loading -->
        <div id="weapp-btn-box" class="btn-allow">
          <span class="loading-tip">正在加载微信配置...</span>
        </div>
      </div>
    </div>
  </div>

</div>

</template>
<style lang="scss">
  .vip-panel{
    margin-top: 1rem;
  }
</style>
<script>
import api from "@/fetch/api"
import { Dialog, Toast } from 'vant'
import VipTravel from './vipTravel.vue'

export default {
  components: {
    VipTravel,
  },
  props:{
    bindStatus:{
      type: Object,
      required: true
    },
    vehicleState:{
      type: String,
      default: '01'
    },
    allBindZero:{
      type: Boolean,
      default: false
    },
    // 普货/危货分类：'PUHUO' | 'WEIHUO' | 'MIXED' | ''（未知/新司机）| 'NONE'（新用户，无任何信息）
    cargoType:{
      type: String,
      default: ''
    },
    // judgePhWh 返回的司机类型：'UNKNOWN' = 全新用户（无任何车辆/计划信息）
    // UNKNOWN 时首页「车辆管理」点击弹框提示，不让进原车辆管理流程
    phWhDriver:{
      type: String,
      default: ''
    },
    // 当前用户的车头号（用于判断车辆是否已绑定）
    chetouhao:{
      type: String,
      default: ''
    },
    // 当前用户的车挂号（用于「不挂号 + 有未完成订单 → 拦截提卸货」判断）
    cheguahao:{
      type: String,
      default: ''
    },
    // judgePhWh 返回的计划列表，老司机但 plans 为空时拦截提卸货
    plans:{
      type: Array,
      default: () => []
    },
    // judgePhWh 是否已返回（成功/失败都算）：false 时点击提卸货先拦住，
    // 避免 cargoType/phWhDriver 还是空串落入「兜底进 AI 对话」分支
    judgeLoaded:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    bindStatus(newValue)
    {
      if(newValue){
        this.ctStatus = newValue.ctStatus;
        this.cgStatus = newValue.cgStatus; 
        this.jsyStatus = newValue.jsyStatus;
        this.yyyStatus = newValue.yyyStatus;
      }
    },
  },
  data() {
    return {
      mapShow: false,
     showWeappDialog: false, // 新增 - 控制小程序弹窗显示
      // weappUsername: 'gh_f03add8cf8b3',  // 注释掉，不再使用原始ID
      weappPath: 'pages/index/index?entry=steamAppointment',
      wxReady: false,           // 微信SDK是否就绪
      wxConfigError: null,      // 配置错误信息
      wxConfigInited: false,    // 微信配置是否已初始化（避免重复初始化）
      weappScheme: 'weixin://dl/business/?appid=wx36a885c557f9014f&path=pages%2Findex%2Findex&env_version=release', // 请替换为您从小程序后台获取的URL Scheme
      // weixin://dl/business/?appid=*wx36a885c557f9014f*&path=*pages/index/index*&query=*QUERY*&env_version=*ENV_VERSION*
      optionList:[
        {
          label:"预约蒸洗",
          jumpUrl:"steam",
          image:require('@/assets/images/home_options_first.png'),
          desc: "槽车蒸洗不用等 • 线上预约快人一步",
          item_style: {
            padding: "10px 0",

            backgroundColor: "#EBFFF6"

          },
        },
        {
          label:"提货装车",
          jumpUrl:"tihuo",
          image:require('@/assets/images/home_options_second.png'),
          desc: "线上便捷约 • 提货装车快 • 省时又高效",
          item_style: {
            padding: "10px 0",

            backgroundColor: "#E7F4FB"

          },        },
        {
          label:"预约卸车",
          jumpUrl:"xiehuo",
          image:require('@/assets/images/home_options_third.png'),
          desc: "提前约卸车 • 资源巧安排 • 轻松无等待",
          item_style: {
            padding: "10px 0",
            backgroundColor: "#FCF7EB"

          },
        }
      ],
      xyState: "00",
      yuyueState: 0,
      slot: 0,
      healthCode: "N",
      isVip:false,
      vipState:"unTravel",
      ctStatus:"",
      cgStatus:"",
      jsyStatus:"",
      yyyStatus:"",
    }
  },
  created: function() {
    this.getxybyopenid();
    
    
  },
  mounted() {
    this.initWxConfig();
    // if (this.isWechat()) {
    //   this.initWxConfig();
    // } else {
    //   this.wxConfigError = '请在微信客户端中打开';
    // }
  },
  methods: {
    // openWeapp() {
    //   this.showWeappDialog = false;
    //   // 直接跳转到 URL Scheme
    //   window.location.href = this.weappScheme;
    // },
    // --- 新增：初始化微信JSSDK配置 ---
    async initWxConfig() {
      // 避免重复初始化
      if (this.wxConfigInited) {
        console.log('微信配置已初始化，跳过');
        return;
      }
      
      // 确保在微信环境中且全局对象存在
      if (!window.wx) {
        console.error('微信 JSSDK 未加载，请检查 public/index.html 中的 script 标签');
        this.wxConfigError = '微信环境异常';
        this.updateWeappBtnBox('error', '微信环境异常，请使用微信打开');
        return;
      }

      // 检查是否在微信环境中
      const isWechat = /MicroMessenger/i.test(navigator.userAgent);
      if (!isWechat) {
        console.warn('非微信环境，跳过微信配置');
        this.wxConfigError = '请在微信中打开';
        this.updateWeappBtnBox('error', '请在微信中打开此页面');
        return;
      }

      try {
        // 1. 获取当前页面的 URL
        // 注意：微信要求签名使用的域名必须与当前页面域名一致
        // iOS 只认首次进入页面的 URL，安卓使用当前页面 URL
        let currentUrl = '';
        
        // 判断是否是 iOS 设备
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        
        if (isIOS) {
          // iOS：使用首次进入页面的 URL（从 sessionStorage 获取）
          const entryUrl = sessionStorage.getItem('wx_entry_url');
          if (entryUrl) {
            currentUrl = entryUrl;
            console.log('iOS 使用首次进入 URL:', currentUrl);
          } else {
            // 首次进入，记录 URL（清理掉 code 等参数）
            currentUrl = window.location.href.split('?')[0].split('#')[0];
            try {
              sessionStorage.setItem('wx_entry_url', currentUrl);
            } catch (e) {
              console.warn('sessionStorage 写入失败:', e);
            }
            console.log('iOS 首次进入，记录 URL:', currentUrl);
          }
        } else {
          // 安卓：使用当前页面 URL（清理掉 code 等参数）
          currentUrl = window.location.href.split('?')[0].split('#')[0];
          console.log('安卓使用当前 URL:', currentUrl);
        }
        
        // 注意：微信要求签名使用的 URL 必须与当前页面 URL 完全一致
        // 开发环境如果使用 localhost，需要后端配置 JS 接口安全域名包含 localhost
        // 或者使用内网穿透工具获得一个与生产环境相同的域名
        
        console.log(`最终使用 URL: ${currentUrl}`);
        console.log('注意：签名 URL 必须与当前页面 URL 完全一致，否则会导致 invalid signature');

        // 2. 根据设备类型处理 URL（iOS 不 encode，安卓需要 encode）
        // 注意：isIOS 已经在上面声明过了，这里直接使用
        let requestUrl;
        
        if (isIOS) {
          // iOS：URL 不 encode
          requestUrl = currentUrl;
          console.log('iOS 请求 URL（不 encode）:', requestUrl);
        } else {
          // 安卓：URL 需要 encode
          requestUrl = encodeURIComponent(currentUrl);
          console.log('安卓请求 URL（已 encode）:', requestUrl);
        }

        // 3. 检查缓存（2小时内有效）
        const cacheKey = 'wx_signature_cache';
        const cacheTimeKey = 'wx_signature_cache_time';
        const cachedData = localStorage.getItem(cacheKey);
        const cachedTime = localStorage.getItem(cacheTimeKey);
        const now = Date.now();
        const CACHE_DURATION = 2 * 60 * 60 * 1000; // 2小时
        
        let signatureData;
        
        if (cachedData && cachedTime && (now - parseInt(cachedTime)) < CACHE_DURATION) {
          console.log('使用缓存的签名数据');
          signatureData = JSON.parse(cachedData);
        } else {
          console.log('从后端获取签名数据');
          try {
            const res = await api.getWxJsapiSignature(requestUrl);
            signatureData = typeof res === 'string' ? JSON.parse(res) : res;
            console.log('获取签名成功:', signatureData);
            
            // 只有接口返回 code 为 200 时才缓存
            const isSuccess = signatureData && (signatureData.code === 200 || signatureData.respCode === 0);
            if (isSuccess) {
              try {
                localStorage.setItem(cacheKey, JSON.stringify(signatureData));
                localStorage.setItem(cacheTimeKey, now.toString());
                console.log('签名数据已缓存');
              } catch (e) {
                console.warn('localStorage 写入失败:', e);
              }
            } else {
              console.log('接口返回非成功状态，不缓存数据');
            }
          } catch (apiError) {
            console.error('调用签名接口失败:', apiError);
            this.wxConfigError = '获取微信签名失败，请稍后重试';
            this.updateWeappBtnBox('error', '获取微信签名失败，请稍后重试');
            return;
          }
        }

        // 检查返回数据 (支持 code 或 respCode)
        const isSuccess = signatureData && (signatureData.code === 200 || signatureData.respCode === 0);
        if (!isSuccess || !signatureData.data) {
          console.error('签名数据无效:', signatureData);
          this.wxConfigError = '签名数据无效';
          this.updateWeappBtnBox('error', '签名数据无效，请联系管理员');
          return;
        }

        const { appId, timestamp, nonceStr, signature } = signatureData.data;
        const vm = this;

        // 3. 调用微信 SDK 的 config 方法
        window.wx.config({
          debug: false, // 生产环境请设置为 false
          appId: appId,
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: [], // 不需要其他 JS 接口
          openTagList: ['wx-open-launch-weapp'] // 必须包含此标签
        });

        // 4. 监听 config 成功和失败事件
        window.wx.ready(function() {
          console.log('微信配置成功');
          vm.wxReady = true;
          vm.wxConfigInited = true; // 标记已初始化
          vm.wxConfigError = null;
          
          // 如果弹窗已经显示，立即插入按钮
          if (vm.showWeappDialog) {
            vm.$nextTick(() => {
              vm.insertWeappLaunchBtn();
            });
          }
        });

        window.wx.error(function(res) {
          console.error('wx.error:', res);
          vm.wxConfigError = res.errMsg || '微信配置失败';
          vm.wxReady = false;
          vm.updateWeappBtnBox('error', '微信配置失败: ' + (res.errMsg || '未知错误'));
        });

      } catch (error) {
        console.error('初始化微信配置失败:', error);
        this.wxConfigError = `初始化失败: ${error.message}`;
        this.updateWeappBtnBox('error', '初始化失败，请刷新页面重试');
      }
    },

    // --- 新增：插入小程序跳转按钮（使用 createElement 替代 innerHTML，更安全）---
    insertWeappLaunchBtn() {
      const box = document.getElementById('weapp-btn-box');
      if (!box) {
        console.error('找不到 weapp-btn-box 容器');
        return;
      }

      // 清空容器
      box.innerHTML = '';

      // 创建 wx-open-launch-weapp 元素
      const launchBtn = document.createElement('wx-open-launch-weapp');
      launchBtn.setAttribute('id', 'launch-btn');
      launchBtn.setAttribute('username', 'gh_f03add8cf8b3');
      launchBtn.setAttribute('path', 'pages/index/index?entry=steamAppointment');
      launchBtn.style.display = 'flex';  // 改为 flex
      launchBtn.style.alignItems = 'center';
      launchBtn.style.justifyContent = 'center';
      launchBtn.style.width = '100%';
      launchBtn.style.height = '100%';

      // 创建 script 元素（wxtag-template）
      const scriptEl = document.createElement('script');
      scriptEl.setAttribute('type', 'text/wxtag-template');
      scriptEl.style.display = 'flex';
      scriptEl.style.alignItems = 'center';
      scriptEl.style.justifyContent = 'center';
      scriptEl.style.width = '100%';
      scriptEl.style.height = '100%';

      // 创建 button 元素
      const buttonEl = document.createElement('button');
      buttonEl.style.width = '100%';
      buttonEl.style.height = '100%';
      buttonEl.style.background = 'transparent';  // 透明背景，让父级背景显示
      buttonEl.style.color = 'white';
      buttonEl.style.border = 'none';
      buttonEl.style.fontSize = '16px';  // 与取消按钮字体大小一致
      buttonEl.style.fontWeight = 'bold';
      buttonEl.style.cursor = 'pointer';
      buttonEl.style.padding = '0';
      buttonEl.style.margin = '0';
      // 水平垂直居中
      buttonEl.style.display = 'flex';
      buttonEl.style.alignItems = 'center';
      buttonEl.style.justifyContent = 'center';
      buttonEl.textContent = '允许';

      // 组装 DOM
      scriptEl.appendChild(buttonEl);
      launchBtn.appendChild(scriptEl);
      box.appendChild(launchBtn);

      console.log('小程序跳转按钮已插入（使用 createElement）');
    },

    // --- 新增：更新按钮容器状态 ---
    updateWeappBtnBox(type, message) {
      const box = document.getElementById('weapp-btn-box');
      if (!box) return;

      if (type === 'loading') {
        box.innerHTML = '<span class="loading-tip">' + message + '</span>';
      } else if (type === 'error') {
        box.innerHTML = '<span class="error-tip">' + message + '</span>';
      }
    },
    // -----------------------------------

    // 新增 - 统一处理所有卡片点击（带防抖）
    handleItemClick: (function() {
      let lastClickTime = 0;
      const DEBOUNCE_TIME = 500; // 500ms 防抖
      
      return function(item, index) {
        const now = Date.now();
        if (now - lastClickTime < DEBOUNCE_TIME) {
          console.log('点击过于频繁，忽略');
          return;
        }
        lastClickTime = now;
        
        if (index === 0 && item.label === "预约蒸洗") {
          // 显示小程序弹窗
          this.showWeappDialog = true;
          
          // 如果微信配置已经完成，在弹窗显示后插入按钮
          if (this.wxReady) {
            this.$nextTick(() => {
              this.insertWeappLaunchBtn();
            });
          }
        } else {
          // 其他卡片（提货装车、预约卸车）走原有逻辑
          this.jumpUrl(item.jumpUrl);
        }
      };
    })(),
    handleMap() {
      this.mapShow = true
    },
    // 中文列表拼接：最后一项前用“和”，其余用“、”
    joinWithAnd(items) {
      if (!items || items.length === 0) return '';
      if (items.length === 1) return items[0];
      return items.slice(0, -1).join('、') + '和' + items[items.length - 1];
    },
    goAIChat() {
      this.$router.push({
        name: 'aiChat'
      });
    },
    jumpClgl(){
      // 已绑定车头和车挂 → 直接进车辆管理页，不再被 phWhDriver/_NEW 等状态拦截
      var vehicleBound = this.vehicleState != '02' && this.chetouhao && this.cheguahao;
      if (vehicleBound) {
        this.$router.push({ name: 'vehicle' });
        return;
      }

      // 全新用户（phWhDriver='UNKNOWN'）→ 弹框提示，跟 cargoType 空 / 普货 同一提示
      // 危货（WEIHUO / MIXED）→ 未绑定车辆时去 addAllCar 绑定；已绑定则跳车辆管理页
      if (this.phWhDriver === 'UNKNOWN') {
        Dialog.alert({
          title: '提示',
          message: '请根据您需要的业务先点击提卸货预约上传车头行驶证正页区分普货还是危货！',
          confirmButtonText: '确定',
        });
        return;
      }
      if (this.cargoType === 'WEIHUO' || this.cargoType === 'MIXED') {
        // 全新司机（PUHUO_NEW / WEIHUO_NEW）也走提示，不要直接跳绑定；
        // 只有老司机危货/混合才按是否已绑定车辆分流
        if (this.phWhDriver && this.phWhDriver.endsWith('_NEW')) {
          Dialog.alert({
            title: '提示',
            message: '请根据您需要的业务先点击提卸货预约上传车头行驶证正页区分普货还是危货！',
            confirmButtonText: '确定',
          });
          return;
        }
        // 已绑定车头和车挂 → 跳车辆管理页；否则仍去 addAllCar 绑定
        vehicleBound = this.vehicleState != '02' && this.chetouhao && this.cheguahao;
        if (vehicleBound) {
          this.$router.push({ name: 'vehicle' });
        } else {
          this.$router.push({ name: 'addAllCar' });
        }
        return;
      }
      if (this.allBindZero || this.cargoType === '' || this.cargoType === 'PUHUO' || this.cargoType === 'NONE') {
        Dialog.alert({
          title: '提示',
          message: '请根据您需要的业务先点击提卸货预约上传车头行驶证正页区分普货还是危货！',
          confirmButtonText: '确定',
        });
        return;
      }
      // 兜底：跳到原车辆管理页
      this.$router.push({
        name: 'vehicle'
      });
    },

    callPhone(){
      window.location.href = 'tel:0510-86092982';

    },

    jumpUrl(type)
    {
      switch(type)
      {
        case "steam":
          // 蒸洗功能已改为小程序跳转，此处不再处理
          break;
        case "tihuo":
        case "xiehuo":
          // judgePhWh 还没返回（含失败重试前）：先拦住，等接口返回后再放行，
          // 防止空 cargoType 走兜底直接进 AI 对话页
          if (!this.judgeLoaded) {
            Toast('车辆信息加载中，请稍后再试');
            break;
          }
          // 老司机（phWhDriver 以 _OLD 结尾）但 judgePhWh 返回的计划列表为空
          // → 拦截提卸货，提示未查到可用计划（带车头号/车挂号）
          if (this.phWhDriver && this.phWhDriver.endsWith('_OLD') && (!this.plans || this.plans.length === 0)) {
            Dialog.alert({
              title: '提示',
              message: '车头号：' + (this.chetouhao || '') + '，车挂号：' + (this.cheguahao || '') + '的车辆未查到该车绑定的可用计划',
              confirmButtonText: '确定',
            });
            break;
          }
          this.judgeAndJump(type);
          break;
      }
    },
    // 普危分流：cargoType 由首页进页面时调一次 judgePhWh 算出来缓存到 prop，
    // 这里直接读 cargoType 决定走对话预约 / 旧预约 / 让用户二选一，**不再重复调 judgePhWh**。
    // cargoType 取值：''（未知/新司机）| 'PUHUO' | 'WEIHUO' | 'MIXED'
    // 入口拦截：调 /listalluse 看是否有未完成订单，有则弹框「你有未完成的订单，不可以再预约！」
    // 并 return，不进入分流。（不管挂不挂号都要拦截）
    judgeAndJump(type) {
      const openid = this.$store.state.wx_info.openid;
      if (!openid) {
        Dialog.alert({ message: '请先登录' });
        return;
      }
      this.checkUnfinishedOrder(type, openid);
    },
    // 调 /ltxt/rest/ltxtCcpdYyzbController/listalluse/{openid}
    // 返回 data 数组非空 → 弹框提示并拦截
    checkUnfinishedOrder(type, openid) {
      const that = this;
      Toast.loading({ message: '检查订单中...', forbidClick: true, duration: 0 });
      api.getNowOrderList(openid)
        .then(function (resData) {
          var res;
          try { res = JSON.parse(resData); } catch (e) { res = null; }
          console.log('[checkUnfinishedOrder] raw=', res);
          // 只要 data 是非空数组就视为有未完成订单（兼容 respCode 是数字 0 / 字符串 "0" / 未返回等情况）
          var hasUnfinished = res && Array.isArray(res.data) && res.data.length > 0;
          // 先关 loading，再延迟一帧弹 Dialog，避免 Toast 和 Dialog 同时出现的视觉重叠
          Toast.clear();
          var showDialog = function () {
            if (hasUnfinished) {
              Dialog.alert({
                title: '提示',
                message: '你有未完成的订单，不可以再预约！',
                confirmButtonText: '确定',
              });
              return;
            }
            // 无未完成订单 → 继续走 cargoType 分流
            that.proceedCargoTypeJump(type);
          };
          setTimeout(showDialog, 250);
        })
        .catch(function (err) {
          console.error('[checkUnfinishedOrder] 失败', err);
          Toast.clear();
          Toast.fail('订单检查失败，请稍后重试');
        });
    },
    // 实际的 cargoType 分流（原 judgeAndJump 主体逻辑）
    proceedCargoTypeJump(type) {
      const resultType = this.cargoType;
      // 全新司机（phWhDriver 以 _NEW 结尾）：普货/危货都先进 AI 对话做判定，
      // 不要提前在首页用车辆绑定状态拦截
      const isNewDriver = this.phWhDriver && this.phWhDriver.endsWith('_NEW');
      if (resultType === 'PUHUO') {
        // 普货：设置 jobType（0=提货，1=卸货）后进 AI 对话预约
        this.handlePuhuoFlow(type);
        return;
      }
      if (resultType === 'WEIHUO') {
        // 危货：全新司机且还没完成绑定时，先走 AI 对话上传车头行驶证判定，
        // 不要直接拦截；已绑定或老司机才走原危货流程
        if (isNewDriver && !this.$store.state.aiChatVehicleBound) {
          this.handlePuhuoFlow(type);
        } else {
          this.handleWeiHuoFlow(type);
        }
        return;
      }
      if (resultType === 'MIXED') {
        // 同时存在普货/危货计划：让用户选择本次类型
        Dialog.confirm({
          title: '选择预约类型',
          message: '检测到您同时存在普货和危货计划，请选择本次预约类型',
          confirmButtonText: '危货预约',
          cancelButtonText: '普货预约',
        }).then(() => {
          // 危货：全新司机且未完成绑定时走 AI 对话判定
          if (isNewDriver && !this.$store.state.aiChatVehicleBound) {
            this.handlePuhuoFlow(type);
          } else {
            this.handleWeiHuoFlow(type);
          }
        }).catch(() => {
          // 普货：走对话预约
          this.handlePuhuoFlow(type);
        });
        return;
      }
      // cargoType 为 ''：首页接口失败 / 无车牌 / 新司机（兜底进对话走 OCR 流程）
      this.handlePuhuoFlow(type);
    },
    // 普货：设置 jobType（0=提货，1=卸货）后进 AI 对话预约
    handlePuhuoFlow(type) {
      localStorage.setItem('ai_job_type', type === 'tihuo' ? '0' : '1');
      // 老司机（PUHUO_OLD / WEIHUO_OLD）→ 创建 ERP 会话时显式传 erp_old_driver 模板
      // 覆盖后端默认 erp_new_driver 选择。其他场景不传 templateCode，让后端按 judgePhWh 自动选
      if (this.phWhDriver === 'PUHUO_OLD' || this.phWhDriver === 'WEIHUO_OLD') {
        localStorage.setItem('ai_template_code', 'erp_old_driver');
        // 老司机走 erp_old_driver 模板，每次从首页进入都应该是新会话流程
        // （后端 createErpSession 默认会复用同 openid 的进行中会话，必须传 force=true 才能拿到新 sessionId）
        localStorage.setItem('ai_force_new_session', '1');
      } else {
        localStorage.removeItem('ai_template_code');
        localStorage.removeItem('ai_force_new_session');
      }
      this.$router.push({ name: 'aiChat' });
    },
    // 危货：走原有旧预约流程；提货时若未绑定车辆则先去绑定
    handleWeiHuoFlow(type) {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      var isNewDriver = this.phWhDriver && this.phWhDriver.endsWith('_NEW');

      // 全新司机（phWhDriver 以 _NEW 结尾）不直接看 aiChatVehicleBound 标记，
      // 因为该标记可能因测试/缓存异常而为 true，导致未绑定过的新用户被拦截。
      // 这里直接查后端真实绑定状态：
      //   - 全部未绑定（'0'）→ 先进 AI 对话做危货判定
      //   - 全部审核通过（'3'）→ 继续危货预约
      //   - 已提交但未全部通过 → 弹窗提示缺哪些项
      if (isNewDriver) {
        Toast.loading({ message: '检查绑定状态中...', forbidClick: true, duration: 0 });
        api.getBindVehicleState(openid)
          .then(function (resData) {
            Toast.clear();
            var res = JSON.parse(resData);
            if (res.respCode == 0) {
              var yhctbazt = String(res.data.yhctbazt || '0');
              // 兼容后端车挂字段名：yhcgbazt / yhcsbazt
              var yhcgbazt = String(res.data.yhcgbazt || res.data.yhcsbazt || '0');
              var yhjsybazt = String(res.data.yhjsybazt || '0');
              var yhyyybazt = String(res.data.yhyyybazt || '0');

              var allZero = yhctbazt === '0' && yhcgbazt === '0' && yhjsybazt === '0' && yhyyybazt === '0';
              var allPassed = yhctbazt === '3' && yhcgbazt === '3' && yhjsybazt === '3' && yhyyybazt === '3';

              console.log('[handleWeiHuoFlow] 全新司机状态:', { yhctbazt, yhcgbazt, yhjsybazt, yhyyybazt, allZero, allPassed, phWhDriver: that.phWhDriver });

              // 从未绑定过 → 先进 AI 对话判定
              if (allZero) {
                that.handlePuhuoFlow(type);
                return;
              }

              // 全部审核通过 → 继续危货预约
              if (allPassed) {
                that.jumpUrlTwo(type);
                return;
              }

              // 已提交但未全部通过：弹窗提示
              that.showBindStatusDialog(yhctbazt, yhcgbazt, yhjsybazt, yhyyybazt);
              return;
            }
            // 接口异常时不拦截全新司机，让他先进对话
            that.handlePuhuoFlow(type);
          })
          .catch(function (err) {
            Toast.clear();
            console.error('[handleWeiHuoFlow] getBindVehicleState 失败', err);
            that.handlePuhuoFlow(type);
          });
        return;
      }

      // 非全新司机（老司机）保持原逻辑
      if (this.$store.state.aiChatVehicleBound) {
        Toast.loading({ message: '检查绑定状态中...', forbidClick: true, duration: 0 });
        api.getBindVehicleState(openid)
          .then(function (resData) {
            Toast.clear();
            var res = JSON.parse(resData);
            if (res.respCode == 0) {
              var yhctbazt = String(res.data.yhctbazt || '0');
              var yhcgbazt = String(res.data.yhcgbazt || res.data.yhcsbazt || '0');
              var yhjsybazt = String(res.data.yhjsybazt || '0');
              var yhyyybazt = String(res.data.yhyyybazt || '0');
              if (yhctbazt === '3' && yhcgbazt === '3' && yhjsybazt === '3' && yhyyybazt === '3') {
                that.jumpUrlTwo(type);
                return;
              }
              that.showBindStatusDialog(yhctbazt, yhcgbazt, yhjsybazt, yhyyybazt);
              return;
            }
            that.jumpUrlTwo(type);
          })
          .catch(function (err) {
            Toast.clear();
            console.error('[handleWeiHuoFlow] getBindVehicleState 失败', err);
            that.jumpUrlTwo(type);
          });
        return;
      }

      // 非 AI 对话危货老司机流程保持原有逻辑
      if (type === 'tihuo' && this.vehicleState == '02') {
        this.$router.push({ name: 'addAllCar' });
        return;
      }
      this.jumpUrlTwo(type);
    },
    // 根据绑定状态拼弹窗提示
    showBindStatusDialog(yhctbazt, yhcgbazt, yhjsybazt, yhyyybazt) {
      var zeroParts = [];
      var pendingParts = [];
      if (yhctbazt === '0') zeroParts.push('车头');
      else if (yhctbazt !== '3') pendingParts.push('车头');
      if (yhcgbazt === '0') zeroParts.push('车挂');
      else if (yhcgbazt !== '3') pendingParts.push('车挂');
      if (yhjsybazt === '0') zeroParts.push('驾驶员');
      else if (yhjsybazt !== '3') pendingParts.push('驾驶员');
      if (yhyyybazt === '0') zeroParts.push('押运员');
      else if (yhyyybazt !== '3') pendingParts.push('押运员');

      var message = '系统区分您为危货';
      if (zeroParts.length > 0) {
        message += '请绑定' + this.joinWithAnd(zeroParts) + '并等待审核通过';
      } else if (pendingParts.length > 0) {
        message += '请等待' + this.joinWithAnd(pendingParts) + '审核通过';
      } else {
        message += '请等待审核通过';
      }
      Dialog.alert({
        title: '提示',
        message: message,
        confirmButtonText: '确定',
      });
    },
    jumpUrlTwo(type)
    {
      var xyState = this.xyState;
      if (xyState == null) {
        Dialog({
          message: '有可用预约信息，请使用后再预约'
        });
        return;
      }

      if (xyState == '0') {
        this.$router.push({
          name: 'appointmentxy',
          params: {
            from: type,
          }
        })
        return;
      }

      this.getSysInfo(type);
    },
    
    getxybyopenid() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api.getxybyopenid(openid).then(function(resData) {
        var res = JSON.parse(resData);
        that.$data.xyState = res.data;
      });
    },
  
    getUploadHealthCode() {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      api.getUploadHealthCode(openid).then(function(resData) {
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          that.$data.healthCode = res.data; //Y/N
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
    //获取系统信息
    getSysInfo(type)
    {
      var openid = this.$store.state.wx_info.openid;
      var that = this;
      //获取系统信息
      api.getSysInfo(openid).then(function(resData) {
        console.log("type=",type)
        var res = JSON.parse(resData);
        if (res.respCode == 0) {
          var sysVersion = res.data.sysVersion;
          //老版本
          if(sysVersion == "OLD")
          {
            if (type == 'th') {
              that.$router.push({
                name: 'appointmentold'
              })
            } else if (type == 'xh') {
              that.$router.push({
                name: 'appointmentxhold'
              })
            }
          }
          //新版本
          else{
            //跳转页面 ，输入准备预约的数量
            that.$router.push({
              name: 'inputYyNumber',
              params: {
                type: type,
              }
            });
          }
        }
      }).catch(function() {
        //Toast.fail('连接失败，请刷新页面');
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.function_list{
  width: 100%;

  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left_function{
    background: #fff;
    height: 10vh;
    width: 48%;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 10px;
    .function_label{

      padding: 0 5px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-weight: 600;
      color: black;
      font-size: 1.125rem !important;
      .function_desc{
        font-size: 0.75rem !important;
        color: #999999;
      }
    }
    .car_img{
      height: 40px;
      width: 40px;
    }
  }
  .right_function{
    background: #fff;
    width: 48%;
    height: 10vh;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    .function_label{
      padding: 0 0 0 5px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-weight: 600;
      color: black;
      font-size: 1.125rem !important;
      .function_desc{
        font-size: 0.75rem !important;
        color: #999999;
      }
    }
    .customer_img{
       height: 55px;
      width: 55px;

    }
  }
}
.panel-item-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 0 10px 0;
  .options-item{
    margin-top: 1vh;
    width: 95vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    height: 10vh;
    .options-item-left{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 2vh;
      padding: 5px 15px;
      font-size: 24rpx;
      color: #999999	;
      .left-label{
        font-weight: 550;
        font-size: 1.25rem !important;
        color: black !important;;
      }
    }
    .options-item-right{
      padding: 2px 5px;
      img{
        height: 50px;
        width: 85px;
      }
      .ai-chat-icon{
        height: 60px;
        width: 60px;
        margin-right: 10px;
      }
    }

  }
  ul{
    li{
       width: 100vw;
      .panel-item{
        background: #FFFFFF;
        margin: 1rem 1rem;
        border-radius: 1rem;
        box-shadow: 4px 5px 5px rgba(190, 190, 190, 0.5);
        position: relative;
        overflow: hidden;
        height: 6rem;
        .left-panel{
          width: 50%;
          float: left;
          .panel-title{
            font-weight: 600;
            font-size: 2rem;
            text-align: center;
            margin-top:1rem;
            position: relative;
            display: inline-block;
            margin-left: 1rem;
          }
          .dots {
            margin-left: 1rem; 
          }
          .dot {
              display: inline-block;
              width: .425rem;
              height: .425rem;
              margin-right: .5rem; 
          }

          .dot1{
            background-color: #FFA500; 
          }
          .dot2{
            background-color: #FFA500;
            opacity: 70%; 
          }
          .dot3{
            background-color: #FFA500;
            opacity: 50%; 
          }
          .dot4{
            background-color: #FFA500;
            opacity: 35%; 
          }
          .dot5{
            background-color: #FFA500;
            opacity: 25%; 
          }
          .dot6{
            background-color: #FFA500; 
            opacity: 15%; 
          }
          
          .dot:last-child {
              margin-right: 0; /* 最后一个点点不需要右边距 */
          }
        }
        .right-panel{
          width: 30%;
          float: left;
          height: 6rem;
          overflow: hidden;
          
          .tihuoIcon{
            width:4.75rem;
            height:4.75rem;
            position: absolute;
            top: 10%;
            right: 14%;
          }

          .steamIcon{
            width:4.75rem;;
            height:4.75rem;;
            position: absolute;
            top: 10%;
            right: 14%;
          }

          .xiehuoIcon{
            width:4.75rem;;
            height:4.75rem;;
            position: absolute;
            top: 10%;
            right: 14%;
          }
        }

        .right-panel::before {
          content: '';
          position: absolute;
          left: 50%;        /* 控制弧形露出比例 */
          top: 50%;
          transform: translateY(-50%);
          width: 300px;        /* 直径=容器高度 */
          height: 300px;
          border-radius: 50%;
          background: #ececec; /* 弧形背景色 */
          z-index: 0;
        }
      }
    }
  }
}

.container {
  position: relative; /* 确保容器可以相对于它定位 */
}
.fab {
  position: fixed; /* 使用固定定位 */
  right: 1rem; /* 距离右边的距离 */
  bottom: 4rem; /* 距离底部的距离 */
  z-index: 1000; /* 确保按钮在其他内容之上 */
}

.van-dialog {
  top:50% !important;
  width: 80%;
  height: 39rem;
  padding: 1rem;
}
.mapImage {
  width: 100%;
  height: 31rem;
}
::v-deep .van-dialog__header {
  padding-top: 10px !important;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

/* 新增 - 弹窗样式 (px转rem) */
.weapp-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.weapp-dialog {
  width: 80%;
  max-width: 18.75rem; /* 300px ÷ 16 = 18.75rem */
  background: white;
  border-radius: 0.75rem; /* 12px ÷ 16 = 0.75rem */
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(3.125rem); /* 50px ÷ 16 = 3.125rem */
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.dialog-header {
  padding: 1rem; /* 16px ÷ 16 = 1rem */
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-header h3 {
  margin: 0;
  font-size: 1.125rem; /* 18px ÷ 16 = 1.125rem */
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem; /* 24px ÷ 16 = 1.5rem */
  color: #999;
  cursor: pointer;
  padding: 0 0.5rem; /* 8px ÷ 16 = 0.5rem */
}

.dialog-content {
  padding: 1.5rem 1rem; /* 24px 16px ÷ 16 = 1.5rem 1rem */
  text-align: center;
}

.dialog-content p {
  margin: 0 0 0.5rem 0; /* 8px ÷ 16 = 0.5rem */
  font-size: 1rem; /* 16px ÷ 16 = 1rem */
  color: #333;
}

.dialog-content .tip {
  font-size: 0.875rem; /* 14px ÷ 16 = 0.875rem */
  color: #999;
}

.dialog-footer {
  display: flex;
  border-top: 1px solid #eee;
  height: 50px;
}

.btn-cancel {
  flex: 1;
  padding: 0.75rem; /* 12px ÷ 16 = 0.75rem */
  background: white;
  border: none;
  font-size: 1rem; /* 16px ÷ 16 = 1rem */
  color: #666;
  cursor: pointer;
  border-right: 1px solid #eee;
}

.btn-allow {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 44px;
  background-color: #07C160;
  color: white;
  font-weight: bold;
  font-size: 1rem; /* 与取消按钮的字体大小保持一致 */
  cursor: pointer;
  padding: 0; /* 移除内边距 */
  margin: 0; /* 移除外边距 */
  border: none; /* 移除边框 */
  border-radius: 0 0 0.75rem 0; /* 右下角圆角，与弹窗保持一致 */
}

/* 确保内部元素也居中 */
.btn-allow > * {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-cancel:active {
  background: #f5f5f5;
}

#weapp-launch-btn {
  display: block !important;
  width: 100%;
}

/* wx-open-launch-weapp 标签样式 */
wx-open-launch-weapp {
  display: block;
  width: 100%;
  height: 100%;
}

wx-open-launch-weapp script[type="text/wxtag-template"] {
  display: block;
  width: 100%;
  height: 100%;
}

/* 允许按钮样式 (如果之前没加的话) */
// .allow-btn {
//   background-color: #07C160;
//   width: 100%;
//   height: 100%;
//   border: none;
//   background-color: #07C160;
//   color: white;
//   font-weight: bold;
//   font-size: 1rem; /* 16px */
//   cursor: pointer;
//   border-radius: 0 0 0.25rem 0; /* 4px */
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
// .allow-btn:active {
//   opacity: 0.8;
// }

.loading-tip, .error-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 0.875rem;
  color: white; /* 改为白色，与按钮背景更协调 */
  text-align: center;
  background-color: #07C160; /* 添加背景色 */
}

.error-tip {
  color: white;
  background-color: #ee0a24; /* 错误状态使用红色背景 */
}
</style>
